// Sleva na kartě produktu: běžnou cenu a procento slevy přesune z obrázku k ceně
function moveCardDiscount() {
    $(".product .p a.image .flag-discount").each(function () {
        const $flag = $(this);
        const $prices = $flag.closest(".p").find(".p-bottom .prices").first();
        const $flags = $flag.closest(".flags-extra");

        if ($prices.length == 0) return;

        const $discount = $("<div class='mydiscount'></div>");
        $flag.children(".price-standard, .price-save").appendTo($discount);
        $discount.appendTo($prices);

        $flag.remove();

        if ($flags.children().length == 0) {
            $flags.remove();
        }
    });
}

$(document).ready(moveCardDiscount);
document.addEventListener("ShoptetDOMContentLoaded", moveCardDiscount);
document.addEventListener("ShoptetDOMPageContentLoaded", moveCardDiscount);
document.addEventListener("ShoptetDOMPageMoreProductsLoaded", moveCardDiscount);
